import axiosInstance from "../../../core/api/axios";
import { useExerciseStore } from "../../Disciplines/stores/exercisesStore";
import { useNewSubjectStore } from "../../Disciplines/stores/newSubjectStore";
import { searchFilterStore } from "../stores/searchFilters";

export async function doSearchRequest(searchString: string) {
  try {
    const category = searchFilterStore.getState().categorySearch;
    const discipline = searchFilterStore.getState().disciplineSearch;
    const setActiveSearchString = searchFilterStore.getState().setActiveSearchString;
    const setSelectedSubjects = useNewSubjectStore.getState().setSelectedSubjects;
    const clearExerciseFilters = useExerciseStore.getState().clearFilters;

    let disciplines = "all";
    let categories = "all";
    const baseUrl = `/search/new_search/${encodeURIComponent(searchString)}`

    if(category.length > 0) {
      const auxC = category.join(',')

      categories = auxC
    }

    if(discipline.length > 0) {
      const auxD = discipline.join(',');

      disciplines = auxD
    }

    const { data } = await axiosInstance.get(`${baseUrl}?category=${categories}&discipline=${disciplines}`)
    setActiveSearchString(searchString); // To define if it's necessary to reset the filters
    setSelectedSubjects([]) // Reset the selected subjects to avoid problems when load the exercises
    clearExerciseFilters() // Clear the exercise filters to avoid problems when load the exercises

    return data
  } catch(e: any) {
    throw new Error(e);
  }
}